// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vc-svg-icon[data-v-2dc3d192]{display:inline-block;stroke:currentColor;stroke-width:0;& path{fill:currentColor}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
